'use client';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

import {defaultLayoutIcons, DefaultVideoLayout} from '@vidstack/react/player/layouts/default';
import {MediaPlayer, MediaProvider} from "@vidstack/react";

export default function VideoPlayer({source}: { source: { videoLink: string } }) {
    return (
        <MediaPlayer src={source.videoLink} playsinline={true} title={source.videoLink}>
            <MediaProvider/>
            <DefaultVideoLayout icons={defaultLayoutIcons}/>
        </MediaPlayer>
    )
}